import { useTranslation } from 'react-i18next';
import ConversionDialog from 'components/Modals/ConversionDialog';
import { useUpgradeAccountSession } from 'services/hooks';
import useAnalytics from 'services/hooks/analytics';
import { events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';

interface PersonalUserStudioExportLimitDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PersonalUserStudioExportLimitDialog = ({
  onClose,
  isOpen,
}: PersonalUserStudioExportLimitDialogProps) => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  const { create: createUpgradeAccountSession } = useUpgradeAccountSession();

  const handleClick = () => {
    track(
      events.upgradeSubscription(
        'studio_export_limit_reached_modal',
        AnalyticsEventLocation.STUDIO
      )
    );
    createUpgradeAccountSession();
  };

  return (
    <ConversionDialog
      title={t('remixer:exportLimit:title')}
      description={t('remixer:exportLimit:descriptionPersonal')}
      closeText={t('remixer:exportLimit:goBack')}
      submitText={t('remixer:exportLimit:ctaPersonal')}
      state={{
        isOpen,
        isLoading: false,
        error: null,
      }}
      action={{
        onClose,
        onSubmit: handleClick,
        onExited: onClose,
      }}
    />
  );
};

export default PersonalUserStudioExportLimitDialog;
